import React, { PropsWithChildren, useEffect } from "react";
import "./Layout.css";
import { Layout, ConfigProvider, FloatButton } from "antd";
import { useLocation } from 'react-router-dom';
// import NavMenu from "./NavMenu";
import Header from "./Header";

const WebFrontLayout = (props: PropsWithChildren) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerBg: "#fff",
            headerHeight: 50,
            headerPadding: "0 20px 0 30px",
            bodyBg: "#fff",
          },
        },
      }}
    >
      <Layout className="web-layout">
        <Header />
        <Layout.Content className="web-layout-content">
          {props.children}
        </Layout.Content>
        <div className='footer'>
          <div>Copyright 2025 WAEI Inc.</div>
        </div>
        <FloatButton.BackTop />
      </Layout>
    </ConfigProvider>
  );
};

export default WebFrontLayout;